import { render, staticRenderFns } from "./AllProperty.vue?vue&type=template&id=234d501b&"
import script from "./AllProperty.vue?vue&type=script&lang=js&"
export * from "./AllProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports